import {
  CountryCodeDictionary,
  CountryTypeZ,
  type CountryType,
} from "@sellar-io/common";
import { InputOption, InputSelect } from "@sellar-io/components";
import { FormField } from "./FormField";

export const CountrySelectField = ({
  label,
  value,
  errorMessage,
  onBlur,
  onChange,
}: {
  label: string;
  value: CountryType | "";
  errorMessage: string | undefined;
  onBlur: () => void;
  onChange: (country: CountryType) => void;
}) => (
  <FormField label={label} errorMessage={errorMessage}>
    <InputSelect
      value={value}
      onBlur={onBlur}
      onChange={(event) => onChange(CountryTypeZ.parse(event.target.value))}
      required
    >
      <InputOption value="" disabled>
        Select a country
      </InputOption>
      {Object.entries(CountryCodeDictionary).map(
        ([countryCode, countryName]) => (
          <InputOption key={countryCode} value={countryCode}>
            {countryName}
          </InputOption>
        ),
      )}
    </InputSelect>
  </FormField>
);
